export default "__VITE_ASSET__B3t3XI5i__"